import React from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Typography,
  Grid,
  makeStyles,
  CircularProgress,
} from '@material-ui/core'

import { TableDataCollecteds } from '../../TableDataCollecteds'
import { SuggestionAlert } from 'components/RmcActionContent/components'
import { LinkedDocumentList } from 'components'

import useDataProcessOptions from 'hooks/useDataProcessOptions'
import useDocuments from 'hooks/useDocuments'

import styles from './styles'
import constants from 'constants/index'
import helpers from 'helpers'

const useStyles = makeStyles(styles)

const DataCollected = ({
  dataCollecteds,
  isLoading,
  dataProcessId,
  hiddenSuggestionAlert,
}) => {
  const classes = useStyles()

  const dataProcessOptions = useDataProcessOptions()
  const { linkedDocuments, data: documentData } = useDocuments()

  const dataProcessOptionsData = dataProcessOptions.data

  const options = dataProcessOptionsData && dataProcessOptionsData.options
  const dataCollectedOptions = options && options.dataCollectedOptions

  const items = helpers.dataProcess.buildDocumentItems(
    documentData,
    linkedDocuments,
  )

  return (
    <>
      {isLoading ? (
        <Box
          id="loadBox"
          display="flex"
          width="100%"
          minHeight="700px"
          justifyContent="center"
          alignItems="center"
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box mt={3} mb={2}>
            <Typography variant="h5">Dados Tratados</Typography>
            <SuggestionAlert
              hidden={hiddenSuggestionAlert}
              sectionName="Dados tratados"
              dataProcessId={dataProcessId}
              sectionTab={
                constants.suggestionChanges.TAB_VIEW_VALUE.DATA_COLLECTEDS
              }
            />
          </Box>
          <Grid container className={classes.dataCollectedContainer}>
            <Grid className={classes.dataCollectedTable} item xs={12}>
              <TableDataCollecteds
                dataCollecteds={dataCollecteds}
                dataProcessId={dataProcessId}
                classes={classes}
                dataCollectedOptions={dataCollectedOptions}
              />
            </Grid>
          </Grid>
          <Box mt={3}>
            <Typography variant="h5">Documentos Anexados</Typography>
          </Box>
          <Box py={2}>
            <LinkedDocumentList items={items} disabledInputs showDocumentId />
          </Box>
        </>
      )}
    </>
  )
}

DataCollected.propTypes = {
  dataCollecteds: PropTypes.array,
  isLoading: PropTypes.bool,
  dataProcessId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hiddenSuggestionAlert: PropTypes.bool,
}

export default DataCollected
